import { render, staticRenderFns } from "./dal-comp-project.vue?vue&type=template&id=1a3f88b2"
import script from "./dal-comp-project.vue?vue&type=script&lang=js"
export * from "./dal-comp-project.vue?vue&type=script&lang=js"
import style0 from "./dal-comp-project.vue?vue&type=style&index=0&id=1a3f88b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports